
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export interface IDeactivateComponent {
	canExit: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const canDeactivateGuard: CanDeactivateFn<IDeactivateComponent> = (component: IDeactivateComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	const canDeactivateService: CanDeactivateService = inject(CanDeactivateService);
	
	console.log(currentState.url, 'state.url');
	if (currentState != null && currentState.url == '/forecast/deep-dive-new') {

		if (!canDeactivateService.getForecastDeepDive()) {
			return confirm(canDeactivateService.getConfirmMessage());
		}
	}

	return true;
};


// @Injectable({
//     providedIn: 'root'
// })
// export class CanDeactivateGuard implements IDeactivateComponent  { 
//     component: Object;
//     route: ActivatedRouteSnapshot;

//     constructor(){
//     }
//     canExit: () => boolean | Observable<boolean> | Promise<boolean>;

//     canDeactivate(component:IDeactivateComponent,
//         route: ActivatedRouteSnapshot, 
//         state: RouterStateSnapshot,
//         nextState: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//         console.log("_________________________THE FUNCATION EXEX_______________________________");
//         // if (component != null && component.canDeactivate() != null) {
//         //     if (component.canDeactivate()) {
//         //         console.log("_________________________THE FUNCATION true");
//         //         return true;
//         //     } else {
//         //         console.log("_________________________THE FUNCATION confirm----------------------");
//         //         return confirm("you have unsave changes");
//         //     }
//         // }
//         return component.canExit ? component.canExit() : true;
//     }
// }


@Injectable({
	providedIn: 'root'
})
export class CanDeactivateService {

	constructor() { }

	IsCanExit: boolean = true;
	getForecastDeepDive(): boolean {
		return this.IsCanExit;
	}

	setForecastDeepDive(IsCanExitParm): boolean {
		this.IsCanExit = IsCanExitParm;
		return this.IsCanExit;
	}

	getConfirmMessage(): string {
		return "You have unsaved change, are you sure you want to leave this page?"
	}
}